module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/commercial-refrigeration/commercial-refrigeration.component.scss
// module id = ./src/app/pages/commercial-refrigeration/commercial-refrigeration.component.scss
// module chunks = main